/** GraphQL documents for company-scoped support FAQs (admin + Help pages). */

export const SUPPORT_FAQS_QUERY = `
  query SupportFaqs {
    supportFaqs {
      id
      question
      answer
      category
      keywords
      status
      createdAt
      updatedAt
    }
  }
`;

export const SUPPORT_FAQS_PUBLISHED_QUERY = `
  query SupportFaqsPublished {
    supportFaqsPublished {
      id
      question
      answer
      category
      keywords
      status
      createdAt
      updatedAt
    }
  }
`;

export const CREATE_SUPPORT_FAQ_MUTATION = `
  mutation CreateSupportFaq($input: CreateSupportFaqInput!) {
    createSupportFaq(input: $input) {
      id
      question
      answer
      category
      keywords
      status
      createdAt
    }
  }
`;

export const UPDATE_SUPPORT_FAQ_MUTATION = `
  mutation UpdateSupportFaq($input: UpdateSupportFaqInput!) {
    updateSupportFaq(input: $input) {
      id
      question
      answer
      category
      keywords
      status
      createdAt
    }
  }
`;

export const DELETE_SUPPORT_FAQ_MUTATION = `
  mutation DeleteSupportFaq($id: String!) {
    deleteSupportFaq(id: $id)
  }
`;
